import type { OooCell } from '~/lib/api/types'
import styles from './ooo-band.module.scss'

type Props = {
  cell: OooCell
  span: number
}

export function OooBand({ cell, span }: Props) {
  const showNote = !!cell.note && span >= 4
  return (
    <div
      className={styles.bandWrap}
      style={{ gridColumn: `span ${span}` }}
      role="gridcell"
      aria-label={`${cell.ooo_kind} from ${cell.spans_from} to ${cell.spans_to}`}
    >
      <div className={styles.band}>
        <span
          className={`${styles.shape} ${styles[`shape_${cell.ooo_kind}`] ?? ''}`}
          aria-hidden
        />
        <span className={styles.kind}>{cell.ooo_kind}</span>
        {showNote && <span className={styles.note}>{cell.note}</span>}
      </div>
    </div>
  )
}
